import { useMutation } from '@tanstack/react-query'

import HeaderPages from '~/components/HeaderPages'
import PageTitle from '~/components/PageTitle'
import { history } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { createPlacementService } from '~/modules/retailMedia/services/placements'
import { FeedbackContext } from '~/components/feedback'

import PlacementForm from '../components/PlacementForm'
import { bodyCreatePlacementDTO } from './dtos/bodyCreatePlacement'
import { useContext } from 'react'

const PlacementsList: React.FC = () => {
  const { toast } = useContext(FeedbackContext)
  const { t } = useAPPTranslation()

  const { mutate: handleCreatePlacement, isPending } = useMutation({
    mutationFn: createPlacementService,
    onSuccess: () => {
      toast.success(t('rm:placements.create.messages.success.message'))
      history.push('/retail-media/placements')
    },
    onError: error => {
      toast.critical(t('common:messages.errorOccurred.message'))
      console.error(error)
    }
  })

  const handleSubmit = (formData: FormDataPlacement) =>
    handleCreatePlacement(bodyCreatePlacementDTO(formData))

  return (
    <>
      <PageTitle title={t('rm:placements.create.pageTitle')} />

      <HeaderPages
        title={t('rm:placements.create.pageTitle')}
        backTo="/retail-media/placements"
        labelBreadcrumb={t('rm:placements.list.backTo')}
      />

      <PlacementForm onSubmit={handleSubmit} isLoading={isPending} />
    </>
  )
}

export default PlacementsList
